<template>
  <pr-box :title="titleBox">

    <div slot="buttons-header">
      <v-btn icon :to="{ name: 'project-form', params: { id: 'new' }}" v-if="!widget">
        <v-icon color="white">add</v-icon>
      </v-btn>
    </div>

    <div>

      <v-data-table
        :headers="headers"
        :items="resources"
        :total-items="totalResources"
        :pagination.sync="orderSync"
        :no-data-text="noDataAvailable"
        :hide-actions="true"
        :loading="searchLoading"
        class="elevation-0">

        <template slot="items" slot-scope="props">

          <td>
            {{ props.item.name }}
          </td>
          <td>
            {{ props.item.responsible_name }}
          </td>
          <td>
            {{ props.item.responsible_email }}
          </td>
          <td>
            {{ props.item.responsible_tel }}
          </td>
          <td>
            {{ props.item.client.name }}
          </td>
          <td>
            {{ props.item.active ? "Ativo" : "Inativo" }}
          </td>
          <td class="text-xs-center">

            <v-tooltip top>
              <v-btn :color="props.item.active ? 'success' : 'dark'" flat icon slot="activator" @click="toggleStatus({ id: props.item.id })">
                <v-icon v-if="props.item.active">toggle_on</v-icon>
                <v-icon v-else>toggle_off</v-icon>
              </v-btn>
              <span>{{ props.item.active ? "Desativar" : "Ativar" }}</span>
            </v-tooltip>

            <v-btn color="primary" flat icon @click="goToForm(props.item.id)">
              <v-icon>mode_edit</v-icon>
            </v-btn>

            <v-btn flat icon color="error" @click="destroy(props.item.id, props.item.name)">
              <v-icon>delete</v-icon>
            </v-btn>

          </td>
        </template>
      </v-data-table>
      <pr-pagination :paginator="paginator"></pr-pagination>
    </div>
  </pr-box>
</template>

<script>
import CrudMixin from '@/components/mixins/CrudMixin';
import ProjectService from '@/features/project/ProjectService';

export default {
  name: 'project-list',
  mixins: [CrudMixin],
  props: {
    widget: {
      default: false,
    },
  },
  data() {
    return {
      headers: [
        {
          text: this.$t('attributes.name'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.project.responsible_name'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.project.responsible_email'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.project.responsible_tel'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.client.name'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.project.status'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('views.fields.actions'),
          sortable: false,
          align: 'rigth',
        },
      ],
    };
  },
  methods: {
    initCrud() {
      this.serviceType = ProjectService;
      this.routerName = 'project';
    },
    async toggleStatus({ id }) {
      await ProjectService.toggleStatus({ id });
      this.search(this.paginator.currentPage);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/features/project/ProjectList.vue